export const GMAPS_API_KEY = "AIzaSyDEH0wbTkFS04g0b-4bgnSGTjnziVliqJw";
